import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { cfetch } from '@confluence/network';

export type SiteUserTraits = {
	attributes: Array<{
		name: string;
		value: string;
	}> | null;
};

export async function fetchSiteUserTraits(
	cloudId: string,
	userId: string,
): Promise<SiteUserTraits> {
	const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`;

	const controller = new AbortController();
	const timeout = setTimeout(() => controller.abort(), 250);

	try {
		return await cfetch(url, { method: 'GET', signal: controller.signal }).then(
			async (res: Response) => {
				if (!res.ok) throw new Error();

				return (await res.json()) as SiteUserTraits;
			},
		);
	} finally {
		clearTimeout(timeout);
	}
}

export const preloadSiteUserTraits = async (): Promise<void> => {
	if (window.__SSR_SITE_USER_TRAITS__) {
		return;
	}

	const { accessStatus, cloudId, userId } = getPreloaderFnContext();

	if (accessStatus !== 'LICENSED_USE_ACCESS' && accessStatus !== 'LICENSED_ADMIN_ACCESS') {
		return;
	}

	if (!cloudId || !userId) {
		return;
	}

	try {
		const data = await fetchSiteUserTraits(cloudId, userId);
		window.__SSR_SITE_USER_TRAITS__ = data;
	} catch (error) {
		return;
	}
};
